export const META_COLS = new Set([
  'duplicate_group_id',
  'group_size',
  'confidence',
  'match_reasons',
  'line_number',
  'shared_co_reg_values',
  'shared_website_values',
  'shared_email_values',
  'shared_phone_values',
  'shared_name_keys',
])

export type Confidence = 'definite' | 'high' | 'medium' | 'low'
export type DecisionType = 'merged' | 'skipped' | 'not_duplicates'
export type StatusFilter = 'all' | 'pending' | 'merged' | 'skipped' | 'not_duplicates'

export interface DuplicateRecord {
  lineNumber: number
  fields: Record<string, string>
}

export interface DuplicateGroup {
  groupId: string
  size: number
  confidence: Confidence
  matchReasons: string
  records: DuplicateRecord[]
  suggestedMerge: Record<string, string>
}

export interface GroupDecision {
  action: DecisionType
  mergedValues?: Record<string, string>
}

export interface ProgressStore {
  [groupId: string]: GroupDecision
}

export interface MergeStats {
  total: number
  pending: number
  merged: number
  skipped: number
  notDuplicates: number
}

export interface GroupSummary {
  id: string
  size: number
  confidence: Confidence
  status: DecisionType | 'pending'
  names: string[]
}

export interface ExportRecord {
  id: string
  filePath: string
  originalCount: number
  newCount: number
  removedCount: number
  mergedGroups: number
  skippedGroups: number
  notDuplicateGroups: number
  exportedBy: string | null
  exportedAt: string
}

export const CONFIDENCE_COLORS: Record<string, { bg: string; text: string }> = {
  definite: { bg: '#e8f5e9', text: '#2e7d32' },
  high:     { bg: '#fff3e0', text: '#e65100' },
  medium:   { bg: '#fff8e1', text: '#f57f17' },
  low:      { bg: '#fce4ec', text: '#c62828' },
}

export const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  pending:         { bg: '#fff3cd', text: '#856404' },
  merged:          { bg: '#d4edda', text: '#155724' },
  skipped:         { bg: '#e2e3e5', text: '#383d41' },
  not_duplicates:  { bg: '#f8d7da', text: '#721c24' },
}
